/**
 * @module app.cm
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { EventAggregator } from 'aurelia-event-aggregator';
import { StoreFocusEvent } from 'app/shared/lib/events';
import * as CM from 'app/cm/models/essette-api';

@autoinject()
export class TaskInterventionIcon extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.object({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    protected task: CM.Task | null = null;

    protected hasRoute: boolean = false;
    protected isIntervention: boolean = false;
    protected isTask: boolean = false;
    protected label: string | null = null;
    protected icon: string | null = null;
    protected route: string | null = null;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(private readonly events: EventAggregator,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        if(!this.task) return;
        this.reload();
    }

    ////****************** Events ***************************************************////
    protected handleLinkClickCapture(): boolean {
        this.events.publish(new StoreFocusEvent());
        return true;
    }

    ////****************** Functions ************************************************////
    public async reload(): Promise<void> {
        await this.checkPermissions();
        this.initialize(this.task);
    }

    protected initialize(task: CM.Task | null) {
        this.isTask = task?.attachedTo?.type?.code === 'CM.Case';
        this.isIntervention = task?.attachedTo?.type?.code === 'CM.CarePlanGoal';
        this.label = this.getLabel();
        this.icon = this.getIcon();
        this.route = this.buildRoute();
        this.hasRoute = (this.isIntervention && this.accountContext.hasRouteAccess('cm.intervention')) || (this.isTask && this.accountContext.hasRouteAccess('cm.task'));
    }

    private async checkPermissions(): Promise<void> {
        if(!this.task) return;

        await this.accountContext.load();
    }

    protected getLabel(): string | null {
        if(this.isIntervention) return 'cm:carePlanIntervention.$';
        if(this.isTask) return 'core:task.$';
        return null;
    }

    protected getIcon(): string | null {
        if(this.isIntervention) return 'ui:icons.carePlan';
        if(this.isTask) return 'ui:icons.task';
        return null;
    }

    protected buildRoute(): string | null {
        if(!this.task) return null;

        if(this.isTask) return this.router.generate('cm.task', { taskId: this.task.id });
        if(this.isIntervention) return this.router.generate('cm.intervention', { interventionId: this.task.id });
        return null;
    }


    ////****************** Service Calls ********************************************////

}
